import {AxiosPromise, AxiosRequestConfig} from 'axios';
import api, {SAP_PROXY_BASE_URL} from 'services/api/api';
import {parameters} from './iframeData';
import {APIPropCode} from 'models/FreedomPay';

const FREEDOMPAY_LB = 'lb://freedompay-service/v1';
export const FREEDOMPAY_BASE_URL = `${SAP_PROXY_BASE_URL}?${FREEDOMPAY_LB}`;

const FreedomPayAPI = (config: AxiosRequestConfig): AxiosPromise => {
  config.baseURL = `${api.defaults.baseURL}${FREEDOMPAY_BASE_URL}`;
  return api.request(config);
};

export const getIframe = async (propCode: string = APIPropCode) => {
  return FreedomPayAPI({
    url: '/iframe',
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      propCode,
      parameters,
    },
  });
};
